import axios from 'axios';

export const CLIENT_API = 'http://localhost:3348/api/v1';
export const SERVER_API = 'https://mail.pulpground.com';

export const clientApi = axios.create({
  baseURL: CLIENT_API,
});

export const serverApi = axios.create({
  baseURL: SERVER_API,
  timeout: 3000,
});

export const resetAuthToken = async token => {
  if (token) {
    clientApi.defaults.headers.Authorization = `bearer ${token}`;
    serverApi.defaults.headers.Authorization = `bearer ${token}`;
  } else {
    clientApi.defaults.headers.Authorization = null;
    serverApi.defaults.headers.Authorization = null;
  }
};
